import React from "react";
import pareja3 from "../../../assets/pareja3.png";
import Button from "../../Button";
import { useNavigate } from "react-router-dom";

const BannerEmpresas2 = ({
    bgColor = "#e9e8f4",
    text = "Impulse la gestión financiera de su organización",
    buttonText = "Conocer dirección de innovación financiera",
    buttonPath = "/empresas/direccion-de-innovacion-financiera",
}) => {
    const navigate = useNavigate();

    return (
        <section
            className="w-full flex flex-col lg:flex-row items-center justify-between gap-10 px-6 sm:px-10 lg:px-16 py-12 lg:py-0"
            style={{ backgroundColor: bgColor }}
        >
            <div className="w-full lg:w-1/3 flex justify-center lg:justify-start">
                <p className="text-[#17038a] font-bold text-3xl sm:text-4xl lg:text-6xl text-center lg:text-left max-w-xl">
                    {text}
                </p>
            </div>
            <div className="w-full lg:w-1/3 flex justify-center">
                <Button
                    text={buttonText}
                    color="bg-[#7727e8]"
                    textColor="text-white"
                    textSize="text-base sm:text-lg"
                    paddingX="px-6 sm:px-8"
                    paddingY="py-2"
                    rounded="rounded-3xl"
                    onClick={() => {
                        window.scrollTo({ top: 0, behavior: "instant" });
                        navigate(buttonPath);
                    }}
                />
            </div>
            <div className="w-full lg:w-1/3 flex justify-center lg:justify-end">
                <img src={pareja3} alt="Pareja" className="object-contain w-48 sm:w-64 lg:w-auto lg:h-[60vh]" />
            </div>
        </section>
    );
};

export default BannerEmpresas2;
